function decodeKey(value) {
  const padding = "=".repeat((4 - value.length % 4) % 4);
  const raw = atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((char) => char.charCodeAt(0)));
}

export async function enablePushNotifications(client, prefix = "") {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    throw new Error("Le notifiche push non sono supportate da questo dispositivo.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Autorizzazione alle notifiche non concessa.");
  const registration = await navigator.serviceWorker.ready;
  const { data } = await client.get(`${prefix}/notifiche/chiave`);
  if (!data.public_key) throw new Error("Le notifiche non sono ancora configurate sul server.");
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: decodeKey(data.public_key),
    });
  }
  await client.post(`${prefix}/notifiche/iscrizione`, subscription.toJSON());
  localStorage.setItem("push_notifications_enabled", "1");
}
